// © Microsoft Corporation. All rights reserved.
/**
 * Config Service v3 endpoint
 */
export const CrsV3Endpoint = "v3";
/**
 * Config Service v3.1 endpoint
 * Will be used for experimentation only.
 */
export const CrsV31Endpoint = "v3.1";
/**
 * Config Service Path
 */
export const CrsPath = "/resolver/api/resolve/";
/**
 * Prong2 flight prefix
 */
export const Prong2FlightPrefix = "prg-pr2-";
/**
 * Peregrine widget specific flights prefix
 */
export const widgetFlightsPrefix = "prg-pw-";
/**
 * Peregrine flights with prefix
 */
export const PeregrineFlightPrefix = "prg-";
/**
 * Git configs indexedDB caching flight
 */
export const GitConfigsIndexedDbTreatment = "prg-gitconfigs-t";
/**
 * Remove page experiments from target scope flight
 */
export const RemoveCrsFDHeadTreatment = "prg-crsfdheadrem";
/**
 * Treatment flight for using Akamai-CRS for Prong 1.
 */
export const Prong1AkamaiCRSCallTreatmentId = "prg-1sw-akp1crs";
/**
 * Prong 1 flights with prefix
 */
export const Prong1FlightsPrefix = "prg-1sw-";
/**
 * Treatment flight for using Akamai endpoint to retrieve CRS configs.
 */
export const AkamaiCRSCallTreatmentId = "prg-callcrsfrakm";
/** Treatment flight for disabling welcome greeting & weather one liner in Anaheim */
export const AnaheimDisableWeatherInHeadFlight = "prg-ntp-noweahd";
/**
 * Treatment flight for using Akamai-CRS for cn domains in ntp.
 */
export const NtpChinaChinaCRSCallTreatmentId = "prg-akntpcrscncl";
/**
 * Akamai base url to call crs used for when treatment flight is detected.
 * Will be used in the ntp flight.
 */
// eslint-disable-next-line msnews-experiences-rules/no-hardcode-asset-path
export const AkamaiBaseUrl = "https://assets.msn.com";
/**
 * Akamai base url to call crs used for when treatment flight is detected.
 * Will be used in the China flight.
 */
export const ChinaAkamaiBaseUrl = "https://assets.msn.cn";
/**
 * Treatment flight for using long PCS cache duration for Prong 2.
 */
export const Prong2PcsDurationTreatmentId = "prg-pr2-pcsdur";
/**
 * Treatment flight for using manual PCS cache treatment for Prong 2.
 */
export const Prong2ManualPcsCacheTreatmentId = "prg-pr2-manupcs";
/**
 * Treatment flight for using Akamai host for Prong2 PCS API
 */
export const Prong2PcsApiUseAkamaiEndpoint = "prg-pr2-akmpcs";
/**
 * Treatment flight id for removing the x-ms-flightId header from ads call.
 */
export const RemoveFlightIdHeaderTreatment = "remflighthead";
/**
 * Holdout treatment flight id for passing page type to ads calls (native, display, video)
 */
export const PassAllAdTypesPageTypeHoldoutTreatment = "prg-ad-pgtype-rf";
/**
 * Treatment flight id for switching UT endpoint to msn domain for AST SDK in display ad
 */
export const DisplayAdUseMSNDomainEndpointTreatment = "prg-ad-astmsn";
/**
 * Treatment flight id for switching UT endpoint to 1P unified endpoint for AST SDK in display ad
 */
export const DisplayAdUse1PEndpointTreatment = "prg-ad-ast1pend";
/**
 * Treatment flight id for sending assigned flights (id and numberline) in display ad request
 */
export const DisplayAdPassFlightsTreatment = "prg-ad-dispflts-t";
/**
 * Treatment flight id for sending AST more debug informaton on performance
 */
export const EnableDisplayCustomEventTreatment = "prg-ad-astce";
//# sourceMappingURL=Flights.js.map